export default "__VITE_ASSET__Cu4$Nuju__"